export const BROWSE = '/promotions/GetAvailableCoupons';

export const GET_APPLIED = '/promotions/PromotionsApplied';
